<style scoped lang="scss">
@import "../mobile";
.molecular-lists{
  margin-top: 40px;
}
.molecular-item .products li{
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 15px;
  display: block;
  .top-con{
    display: flex;
    align-items: center;
  }
  &:last-child{
    border:0;
  }
  .info{
    padding-top: 0;
  }
  .deliver-num{
    padding:10px;
    background: rgba(37, 167, 165, .1);
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    input{
      width:60px;
      text-align: center;
      border-bottom: 1px solid #014492;
    }
  }
}
.btn-action{
  bottom:10px;
}
.page-title{
  position: fixed;
  top:0;
  left:0;
  right:0;
  line-height: 60px;
  height:60px;
  font-size: 17px;
  text-align: center;
  font-weight: bold;
  background: #fff;
  z-index: 1;
}
</style>
<template>
  <div class="wrap-app">
    <qk-back/>
    <div class="page-title">商品发货</div>
    <div class="molecular-lists">
      <div class="molecular-item">
        <ul class="products">
          <li v-for="item in goodsLists" :key="item.id">
            <div class="top-con">
              <img :src="item.imgUrl" class="pro-img">
              <div class="info">
                <div class="title">
                  {{item.name}}
                  <span class="num">x{{item.needPayQuantity}}</span>
                </div>
                <p class="mt5">货号：{{item.skuCode}}</p>
                <div class="spec mt5">
                  规格：{{item.spec}}
                  <span class="fz14 text-primary" :class="item.needSendQuantity > 0 ? 'text-danger' : 'text-primary'">{{item.needSendQuantity > 0 ? `剩余数：${item.needSendQuantity}` : '发货数：0'}}</span>
                </div>
              </div>
            </div>
            <div class="deliver-num" v-show="item.needSendQuantity > 0">发货数量：<input type="number" v-model="item.sendNums" @input="inputSendNums(item)" v-int></div>
          </li>
        </ul>
      </div>
      <div class="btn-action">
        <button class="btn btn-sencond btn-block" @click="bindSend"></button>
      </div>
    </div>
  </div>
</template>

<script>
import { prodcutOrdersDetail, productOrdersSend } from '@/services/api.index'
export default {
  data () {
    return {
      goodsLists: [],
      id: this.$route.query.id
    }
  },
  created() {
    this.getDetails()
  },
  methods: {
    getDetails () {
      prodcutOrdersDetail(this.id).then(res => {
        res.data.items.map(item => {
          item.sendNums = item.needSendQuantity
        })
        this.goodsLists = res.data.items
      })
    },
    // 订单发货
    bindSend () {
      let items = []
      let validateSend = true
      const sendGoods = this.goodsLists.filter(item => item.sendNums > 0)
      if (sendGoods.length === 0) {
        this.$toast('请添加发货商品数量')
        return
      }
      this.goodsLists.map(item => {
        if (item.sendNums > item.needSendQuantity) {
          validateSend = false
        }
        if (item.sendNums > 0) {
          items = items.concat({
            orderItemId: item.id,
            sendQuantity: Number(item.sendNums)
          })
        }
      })
      if (!validateSend) {
        this.$toast('发货数量不能大于剩余商品数量')
        return
      }
      productOrdersSend(this.id, items).then(() => {
        this.$toast('提交发货成功！')
        this.$router.push('/molecular')
      })
    },
    inputSendNums (item, index) {
      if (item.sendNums > item.needSendQuantity) {
        item.sendNums = item.needSendQuantity
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/molecular/deliver.vue